export default function Hero() {
  return (
    <section className="relative min-h-[70vh] flex items-center justify-center px-8 pt-24">
      <div className="absolute inset-8 rounded-[40px] overflow-hidden bg-black">
        <img
          src="https://static.readdy.ai/image/a9484c237c280a31654c8c92f5f19b1a/019be4b6e99dcc252237705f2fbab046.png"
          alt="About Patriot Defense Technologies"
          className="w-full h-full object-contain"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>
      </div>

      <div className="relative z-10 text-center max-w-4xl mx-auto">
        <span className="inline-block px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full text-white/90 text-sm font-medium mb-6">
          About Our Company
        </span>
      </div>
    </section>
  );
}
